import styled from 'styled-components'

export const StyledBannersPage = styled('div')``
